var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrategyMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.938,
    height: 32.47,
    viewBox: "0 0 38.938 32.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "strategy",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13814",
    "data-name": "Path 13814",
    d: "M219.257,41.116a5.454,5.454,0,1,0,5.454,5.454,5.46,5.46,0,0,0-5.454-5.454Zm0,8.625a3.171,3.171,0,1,1,3.171-3.171A3.175,3.175,0,0,1,219.257,49.741Z",
    transform: "translate(-185.772 -38.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13815",
    "data-name": "Path 13815",
    d: "M8.557,34.165a1.142,1.142,0,0,0,1.614,0L13.137,31.2,16.1,34.165a1.141,1.141,0,0,0,1.614-1.614l-2.967-2.966,2.966-2.966A1.141,1.141,0,0,0,16.1,25L13.137,27.97,10.171,25a1.141,1.141,0,0,0-1.614,1.614l2.966,2.966L8.557,32.55a1.142,1.142,0,0,0,0,1.614Z",
    transform: "translate(-7.145 -24.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13816",
    "data-name": "Path 13816",
    d: "M132.843,197.693a1.142,1.142,0,0,0-1.614,0l-2.966,2.966-2.966-2.966a1.141,1.141,0,1,0-1.614,1.614l2.966,2.966-2.966,2.966a1.141,1.141,0,0,0,1.614,1.614l2.966-2.966,2.966,2.966a1.141,1.141,0,0,0,1.614-1.614l-2.966-2.966,2.966-2.966A1.141,1.141,0,0,0,132.843,197.693Z",
    transform: "translate(-107.176 -174.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13817",
    "data-name": "Path 13817",
    d: "M25.755,49.464l-4.6-4a1.141,1.141,0,0,0-1.5,1.723L22.1,49.307A19.934,19.934,0,0,0,8.255,57.2a21.918,21.918,0,0,0-3.438,6.9,5.453,5.453,0,1,0,2.318.228,19.868,19.868,0,0,1,3.005-5.835,17.51,17.51,0,0,1,12.279-6.924l-2.274,2.616a1.141,1.141,0,0,0,1.723,1.5l4-4.6A1.141,1.141,0,0,0,25.755,49.464ZM8.625,69.509a3.171,3.171,0,1,1-3.171-3.171A3.175,3.175,0,0,1,8.625,69.509Z",
    transform: "translate(0 -42.493)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyMap);
export default __webpack_public_path__ + "static/media/strategy-map.5632aa4ee3b516b65827379f22395a26.svg";
export { ForwardRef as ReactComponent };